export default __webpack_public_path__ + "static/media/ashu-weds-sarah.94c2582f.png";